module.exports = __webpack_public_path__ + "img/TZS09526.9f62ad33.jpeg";